import {ICity} from "../../core/api/dto/City.g";
import {actionCreator} from "../../core/store/common/actionCreator";

export class CityAction {
    public static getAll = actionCreator.async<IEmpty, ICity[], Error>("City/DATA");
}
